import { render, staticRenderFns } from "./SupplierCard.vue?vue&type=template&id=19ae9024&scoped=true"
import script from "./SupplierCard.vue?vue&type=script&lang=js"
export * from "./SupplierCard.vue?vue&type=script&lang=js"
import style0 from "./SupplierCard.vue?vue&type=style&index=0&id=19ae9024&prod&lang=scss&scoped=true"
import style1 from "./SupplierCard.vue?vue&type=style&index=1&id=19ae9024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae9024",
  null
  
)

export default component.exports